import NotificationReceiverUserIdRelationView from './NotificationReceiverUserIdRelationView'

export default NotificationReceiverUserIdRelationView
